var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgGarantia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "96px",
    viewBox: "0 0 76 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_garantia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-3137.000000, -428.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 5.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_garantia",
    transform: "translate(3140.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,62.931319 C0,71.1182726 0,71.1182705 7.77777706,76.3363286 L29.1666667,88.616761 C32.377261,90.4610746 37.622739,90.4610746 40.8333333,88.616761 L62.2222251,76.3363286 C70,71.1182705 70,71.1182726 70,62.931319 L70,40.5746393 C70,32.3876857 70,32.3876835 62.2222251,27.1696254 L40.8333333,14.8891957 C37.622739,13.0448821 32.377261,13.0448821 29.1666667,14.8891957 L7.77777706,27.1696254 C0,32.3876835 0,32.3876857 0,40.5746393 L0,62.931319 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8707586,25.3255763 L59.8707586,13.4949782 C59.8707586,4.49832607 55.3487947,0 46.3048668,0 L23.695047,0 C14.6511191,0 10.1291551,4.49832607 10.1291551,13.4949782 L10.1291551,25.0106927",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4264227,44.4432872 C40.8333995,45.0730529 41.7377947,45.7028172 42.4160893,45.8827502 L47.0284903,47.052316 C49.8773276,47.7720482 50.646063,50.2011434 48.7920578,52.4503064 L45.7623416,56.0939524 C45.3101452,56.6787348 44.9483877,57.7133487 44.9936074,58.4330808 L45.2649271,63.1563283 C45.4458057,66.0802402 43.3657003,67.5646868 40.6525218,66.4850886 L36.2210003,64.7307356 C35.5427056,64.460836 34.4122138,64.460836 33.7339192,64.7307356 L29.3023923,66.4850886 C26.5892138,67.5646868 24.5091122,66.035257 24.6899908,63.1563283 L24.9613062,58.4330808 C25.0065258,57.7133487 24.6447684,56.6337515 24.192572,56.0939524 L21.1628558,52.4503064 C19.3088506,50.2011434 20.077586,47.7720482 22.9264233,47.052316 L27.5388286,45.8827502 C28.2623428,45.7028172 29.1667343,45.0280696 29.5284914,44.4432872 L32.1060094,40.4397758 C33.7339165,38.0106796 36.2662184,38.0106796 37.8489057,40.4397758 L40.4264227,44.4432872 Z",
    id: "Vector"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgGarantia);
export default __webpack_public_path__ + "static/media/svg_garantia.27f95607cf641455de5ba372687b36f7.svg";
export { ForwardRef as ReactComponent };